import { Typography } from "@mui/material";
import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium";
import { CalendarEntryShell } from "../../CurriculumManagementAdmin/components/AttendanceCalendar";
import { attendedEntrySx } from "./styles";

/**
 * A training inside a calendar day cell, from the agent's point of view: green with a badge icon
 * once they have attended it, otherwise the neutral entry the admin calendar uses. Replaces the
 * admin's attendee count, which is not the agent's to see.
 */
const AgentCalendarEntry = ({ training, onSelect }) => (
	<CalendarEntryShell
		training={training}
		onSelect={onSelect}
		tooltip={`${training.title} — ${training.curriculumTitle}${training.attended ? " · Attended" : ""}`}
		sx={training.attended ? attendedEntrySx : undefined}
	>
		<Typography sx={{ flex: 1, minWidth: 0, fontSize: "0.68rem", fontWeight: 700, lineHeight: 1.25 }} noWrap>
			{training.title}
		</Typography>

		{training.attended && <WorkspacePremiumIcon sx={{ fontSize: 13, flexShrink: 0 }} />}
	</CalendarEntryShell>
);

export default AgentCalendarEntry;
